import React from 'react';

const TagSearch = ({ searchQuery, onSearchChange }) => {
  return (
    <div id="tagSearchContainer" className="flex-column">
      <div className="tagSearchWrapper flex-row">
        <img className="searchIcon" src={'/elements/searchIcon.svg'} alt="search" />
        <input 
          type="text" 
          className="tagSearchInput" 
          placeholder="ПОИСК ПО ТЕГАМ" 
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      <img className="tagSearchStick" src={'elements/searchByTagStick.svg'} alt="stick" />
    </div>
  );
};

export default TagSearch;